import React from 'react';
import Waypoint from 'react-waypoint';
import GoogleMapsLoader from 'google-maps';

import marker from '../../../assets/target.png';
import './Contacts.css';
import { GOOGLE_API_KEY } from '../../../constants';

export default class Contacts extends React.PureComponent {
    componentDidMount() {
        this.initializeGoogleMaps();
        window.scrollTo(0, 0);
    }

    initializeGoogleMaps = () => {
        GoogleMapsLoader.KEY = GOOGLE_API_KEY;
        GoogleMapsLoader.load(google => {
            const MAPTYPE_ID = 'custom_style';

            const featureOpts = [
                {
                    featureType: 'all',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#be9eff'
                        }
                    ]
                },
                {
                    featureType: 'all',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            gamma: 0.01
                        },
                        {
                            lightness: 20
                        }
                    ]
                },
                {
                    featureType: 'all',
                    elementType: 'labels.text.stroke',
                    stylers: [
                        {
                            saturation: -31
                        },
                        {
                            lightness: -33
                        },
                        {
                            weight: 2
                        },
                        {
                            gamma: 0.8
                        }
                    ]
                },
                {
                    featureType: 'all',
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            visibility: 'off'
                        }
                    ]
                },
                {
                    featureType: 'administrative.country',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            lightness: '100'
                        },
                        {
                            saturation: '100'
                        },
                        {
                            visibility: 'on'
                        }
                    ]
                },
                {
                    featureType: 'landscape',
                    elementType: 'geometry',
                    stylers: [
                        {
                            lightness: 30
                        },
                        {
                            saturation: 30
                        }
                    ]
                },
                {
                    featureType: 'poi',
                    elementType: 'geometry',
                    stylers: [
                        {
                            saturation: 20
                        }
                    ]
                },
                {
                    featureType: 'poi.park',
                    elementType: 'geometry',
                    stylers: [
                        {
                            lightness: 20
                        },
                        {
                            saturation: -20
                        }
                    ]
                },
                {
                    featureType: 'road',
                    elementType: 'geometry',
                    stylers: [
                        {
                            lightness: 10
                        },
                        {
                            saturation: -30
                        }
                    ]
                },
                {
                    featureType: 'road',
                    elementType: 'geometry.stroke',
                    stylers: [
                        {
                            saturation: 25
                        },
                        {
                            lightness: 25
                        }
                    ]
                },
                {
                    featureType: 'water',
                    elementType: 'all',
                    stylers: [
                        {
                            lightness: -20
                        }
                    ]
                }
            ];

            const fiitLatLng = new google.maps.LatLng(48.153106, 17.071661);
            const feiLatLng = new google.maps.LatLng(48.151965, 17.072995);
            const fmpiLatLng = new google.maps.LatLng(48.151183, 17.070258);

            const mapOptions = {
                zoom: 16,
                scrollwheel: true,
                panControl: false,
                mapTypeControl: false,
                streetViewControl: false,
                center: feiLatLng,
                mapTypeControlOptions: {
                    mapTypeIds: [google.maps.MapTypeId.ROADMAP, MAPTYPE_ID]
                },
                mapTypeId: MAPTYPE_ID
            };

            const map = new google.maps.Map(document.getElementById('canvas-map'), mapOptions);

            // eslint-disable-next-line no-new
            new google.maps.Marker({
                position: fiitLatLng,
                map,
                icon: marker
            });
            // eslint-disable-next-line no-new
            new google.maps.Marker({
                position: feiLatLng,
                map,
                icon: marker
            });
            // eslint-disable-next-line no-new
            new google.maps.Marker({
                position: fmpiLatLng,
                map,
                icon: marker
            });

            const styledMapOptions = {
                name: 'Custom Style'
            };

            const customMapType = new google.maps.StyledMapType(featureOpts, styledMapOptions);

            map.mapTypes.set(MAPTYPE_ID, customMapType);
        });
    };

    render() {
        return (
            <section id="contacts-section">
                <div className="container">
                    <div className="contacts">
                        <div className="page-header text-center">
                            <h1>CONTACTS</h1>
                        </div>
                        <div className="contacts-middle columns is-multiline">
                            <div className="column is-6-desktop is-12-tablet is-12-mobile left-column">
                                <div className="info-row">
                                    <h2>
                                        <i className="fas fa-map-marker-alt" />
                                        Location
                                    </h2>
                                    <ul>
                                        <li>
                                            Faculty of Informatics and Information Technologies, STU
                                            (Registration point)
                                        </li>
                                        <li>
                                            Faculty of Electrical Engineering and Information
                                            Technology STU
                                        </li>
                                        <li>Faculty of Mathematics, Physics and Informatics, UK</li>
                                        <li>Ilkovicova 2, Bratislava, Slovakia</li>
                                    </ul>
                                </div>
                                <div className="info-row">
                                    <h2>
                                        <i className="fas fa-car" />
                                        GPS
                                    </h2>
                                    <p>48.153106, 17.071661</p>
                                </div>
                                <div className="info-row travel">
                                    <div className="bus">
                                        <h2>
                                            <i className="fas fa-bus" />
                                            BUS
                                        </h2>
                                        <p>30, 31, 32, 37, 39, 92, 192 (Zoo)</p>
                                        <p>29, 32</p>
                                    </div>
                                    <div className="tram">
                                        <h2>
                                            <i className="fas fa-train" />
                                            TRAMWAY
                                        </h2>
                                        <p>X6 (Botanicka zahrada)</p>
                                    </div>
                                </div>
                                <div className="info-row">
                                    <h2>
                                        <i className="far fa-envelope" />
                                        E-MAIL
                                    </h2>
                                    <p>info@openslava.sk</p>
                                </div>
                            </div>
                            <div className="column is-6-desktop is-full-touch right-column">
                                <Waypoint bottomOffset="45%" topOffset="45%">
                                    <div id="canvas-map" />
                                </Waypoint>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
